var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalletCartGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_15960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 6.78759C30.8379 3.69785 26.7282 2 22.3606 2C17.987 2 13.8833 3.69785 10.7936 6.78759C7.70385 9.87732 6 13.987 6 18.3546C6 27.1918 14.3573 34.5472 18.8509 38.4948C19.4748 39.0468 20.0088 39.5208 20.4408 39.9167C20.9807 40.4207 21.6706 40.6727 22.3606 40.6727C23.0505 40.6727 23.7405 40.4207 24.2744 39.9167C24.7064 39.5208 25.2463 39.0468 25.8703 38.4948C30.3579 34.5472 38.7152 27.1918 38.7152 18.3546C38.7152 13.987 37.0173 9.87732 33.9276 6.78759Z",
    fill: "#3D8B30",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2331 24.219V23.4328H14.2559V24.219C14.4123 24.181 14.5764 24.1618 14.7445 24.1618C14.9125 24.1618 15.0766 24.181 15.2331 24.219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.233 13.7981L16.5653 12.5423C16.6951 12.4239 16.7447 12.2446 16.6951 12.0766L16.1988 10.3359C16.1415 10.1374 15.9583 10 15.7521 10H14.2559V21.8407H15.2331L15.233 13.7981ZM15.233 10.4618H15.7521L16.2483 12.2024L15.2329 13.1605L15.233 10.4618Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7444 24.5435C13.7787 24.5435 13 25.326 13 26.2879C13 27.2536 13.7787 28.0323 14.7444 28.0323C15.7063 28.0323 16.4889 27.2536 16.4889 26.2879C16.4889 25.326 15.7063 24.5435 14.7444 24.5435ZM16.0882 26.5972L15.2942 26.4712C15.2866 26.5017 15.2751 26.5285 15.2559 26.5552L15.9087 27.0248C15.7689 27.239 15.6607 27.329 15.4773 27.4599L15.004 26.8071C14.9773 26.8224 14.9507 26.8339 14.92 26.8415L15.046 27.6392C14.845 27.6794 14.6359 27.6817 14.4352 27.6353L14.5611 26.8413C14.5345 26.8337 14.5077 26.8223 14.481 26.807L14.0038 27.4597C13.81 27.3306 13.689 27.2033 13.5725 27.0246L14.2252 26.5513C14.2099 26.5246 14.1985 26.4979 14.1909 26.4673L13.3931 26.597C13.3492 26.3687 13.3442 26.22 13.397 25.9825L14.191 26.1123C14.1986 26.0818 14.21 26.055 14.2254 26.0283L13.5687 25.5511C13.739 25.3125 13.8576 25.2148 14.0077 25.1236L14.4811 25.7725C14.5077 25.7572 14.5345 25.7458 14.5613 25.7382L14.4353 24.9443C14.6331 24.8986 14.8422 24.8997 15.0461 24.9404L14.9202 25.7382C14.9507 25.7457 14.9774 25.7572 15.0042 25.7725L15.4737 25.1236C15.6251 25.2157 15.7429 25.3133 15.9127 25.5511L15.2598 26.0245C15.2751 26.0513 15.2866 26.0781 15.2942 26.1085L16.0843 25.9826C16.1366 26.2184 16.1324 26.3665 16.0882 26.5972Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5655 12.3367L24.7457 12.2076L24.926 12.3367L25.1061 12.2076L25.2864 12.3367L25.4666 12.2076L25.6468 12.3367V10.8949H24.2051V12.3367L24.3853 12.2076L24.5655 12.3367Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3853 20.1149L24.5655 20.244L24.7457 20.1149L24.926 20.244L25.1061 20.1149L25.2864 20.244L25.4666 20.1149L25.6468 20.244V18.8023H24.2051V20.244L24.3853 20.1149Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1049 18.8024H26.0281V20.9858L25.4669 20.5849L25.2874 20.7147L25.108 20.5849L24.9248 20.7147L24.7453 20.5849L24.5659 20.7147L24.3868 20.5849L23.8219 20.9858V18.8024H19.7492L19.749 26.3144H30.1051L30.1049 18.8024ZM23.2381 25.1614H20.9123V24.7739H23.2381V25.1614ZM23.2381 24.3862H20.9123V23.9986H23.2381V24.3862Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1048 10.8931H26.0279V13.0804L25.4668 12.6758L25.2873 12.8056L25.1081 12.6758L24.9249 12.8056L24.7455 12.6758L24.566 12.8056L24.3867 12.6758L23.8218 13.0805V10.8933H19.749V18.4206H30.1051L30.1048 10.8931ZM23.238 17.2559H20.9122V16.8683H23.238V17.2559ZM23.238 16.4805H20.9122V16.093H23.238V16.4805Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1265 26.6951H18.9859L17.7028 22.2218H14.1133V23.0514H16.2879L17.5865 27.6528H30.6964C30.7546 27.6528 30.8127 27.6256 30.8475 27.5753L31.2816 27.0055C31.3787 26.8813 31.2856 26.6951 31.1267 26.6951L31.1265 26.6951ZM18.0374 26.7863C17.8265 26.7863 17.6557 26.6155 17.6557 26.4046C17.6557 26.1937 17.8265 26.0229 18.0374 26.0229C18.2481 26.0229 18.4191 26.1937 18.4191 26.4046C18.4191 26.6153 18.2481 26.7863 18.0374 26.7863Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_15960",
    x: 0.5,
    y: 0.5,
    width: 43.7148,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_15960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_15960",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletCartGreenIcon);
export default __webpack_public_path__ + "static/media/PalletCartGreenIcon.6c966e25f8626f17cdbbd98985b537eb.svg";
export { ForwardRef as ReactComponent };